export default __webpack_public_path__ + "static/media/Merchant_spotlight.2d91b3fb.png";